module.exports = __webpack_public_path__ + "img/internet.c76be573.jpg";